import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const list_employee = 'organization/list-employee';
const list_job_lvl = 'organization/list-job-level';
const create_job_lvl = 'organization/create-job-level';
const update_job_lvl = 'organization/update-job-level';
const list_structure = 'organization/list-structure';
const detail_structure = 'organization/detail-structure';
const create_structure = 'organization/create-structure';
const create_node_structure = 'organization/create-structure-node';
const view_structure = 'organization/view-structure-organization';
const employee_structure = 'organization/view-structure-employee';
const create_employee_structure = 'organization/create-employee-node';
const update_structure = 'organization/update-structure';
const update_employee = 'organization/update-employee';
const update_node_employee = 'organization/update-employee-node';
const import_process = 'organization/import';
const import_structure_update = 'organization/import-update-structure';
const import_employee_update = 'organization/import-update-employee';
const focus_position = 'organization/structure-focus-position';
const focus_positionEmployee = 'organization/employee-focus-position';
const bank_list = 'bank/list';
const create_structure_copy_board = 'structure/import-from-another-board';
const create_employee_copy_board = 'employee/import-from-another-board';
const list_directorate = 'directorate/list';
const create_directorate = 'directorate/create';
const update_directorate = 'directorate/update';
const delete_directorate = 'directorate/delete';
const copy_employee = 'employee/copy';
const copy_structure = 'structure/copy';
const list_division = 'wa/list-division';
const add_employee = 'organization/create-employee';
const edit_employee = 'organization/update-employee';
const list_structure_noLimit = 'organization/list-report-to';

export const apiEmployee = async (val) => {
  const datas = await http.post(`${URL + list_employee}`, val);

  return datas.data.data;
};
export const apiOrganization = async (val) => {
  const datas = await http.post(`${URL + list_structure}`, val);

  return datas.data.data;
};
export const apiDetailStructure = async (val) => {
  const datas = await http.post(`${URL + detail_structure}`, val);

  return datas.data.data;
};
export const apiViewStructure = async (val) => {
  const datas = await http.post(`${URL + view_structure}`, val);
  return datas.data.data;
};
export const apiUpdateStructure = async (val) => {
  const datas = await http.post(`${URL + update_structure}`, val);
  return datas.data;
};
export const apiCreateNodeStructure = async (val) => {
  const datas = await http.post(`${URL + create_node_structure}`, val);
  return datas.data;
};
export const apiCreateNodeEmployee = async (val) => {
  const datas = await http.post(`${URL + create_employee_structure}`, val);
  return datas.data;
};
export const apiCreateStructure = async (val) => {
  const datas = await http.post(`${URL + create_structure}`, val);
  return datas.data;
};
export const apiEmployeeViewStructure = async (val) => {
  const datas = await http.post(`${URL + employee_structure}`, val);

  return datas.data.data;
};
export const apiJobLvl = async (val) => {
  const datas = await http.post(`${URL + list_job_lvl}`, val);

  return datas.data.data;
};
export const apiUpdateEmployee = async (val) => {
  const datas = await http.post(`${URL + update_employee}`, val);

  return datas.data.data;
};
export const apiUpdateNodeEmployee = async (val) => {
  const datas = await http.post(`${URL + update_node_employee}`, val);

  return datas.data;
};
export const apiCreateEmployee = async (val) => {
  if (val === 'success') {
    return true;
  }
  throw Error;
};
export const apiImportProcessOrg = async (val) => {
  const datas = await http.post(`${URL + import_process}`, val);
  return datas.data.data;
};
export const apiCreateJobLvl = async (val) => {
  const datas = await http.post(`${URL + create_job_lvl}`, val);
  return datas.data;
};
export const apiUpdateJobLvl = async (val) => {
  const datas = await http.post(`${URL + update_job_lvl}`, val);
  return datas.data;
};
export const apiFocusPositionStructure = async (val) => {
  const datas = await http.post(`${URL + focus_position}`, val);
  return datas.data.data;
};
export const apiFocusPositionEmployee = async (val) => {
  const datas = await http.post(`${URL + focus_positionEmployee}`, val);
  return datas.data.data;
};
export const apiBankList = async (val) => {
  const datas = await http.post(`${URL + bank_list}`, val);
  return datas.data.data;
};
export const apiImportStructureUpdate = async (val) => {
  const datas = await http.post(`${URL + import_structure_update}`, val);
  return datas.data.data;
};
export const apiImportEmployeeUpdate = async (val) => {
  const datas = await http.post(`${URL + import_employee_update}`, val);
  return datas.data.data;
};
export const apiCreateStructureCopyBoard = async (val) => {
  const datas = await http.post(`${URL + create_structure_copy_board}`, val);
  return datas.data;
};
export const apiCreateEmployeeCopyBoard = async (val) => {
  const datas = await http.post(`${URL + create_employee_copy_board}`, val);
  return datas.data;
};
export const apiListDirectorate = async (val) => {
  const datas = await http.post(`${URL + list_directorate}`, val);
  return datas.data.data;
};
export const apiCreateDirectore = async (val) => {
  const datas = await http.post(`${URL + create_directorate}`, val);
  return datas.data;
};
export const apiUpdateDirectore = async (val) => {
  const datas = await http.post(`${URL + update_directorate}`, val);
  return datas.data;
};
export const apiDeleteDirectorate = async (val) => {
  const datas = await http.post(`${URL + delete_directorate}`, val);
  return datas.data;
};

export const apiCopyEmployee = async (val, direct) => {
  const datas = await http.post(`${URL + copy_employee}`, val);
  if (direct) {
    return datas.data;
  }
  return datas.data.data;
};
export const apiCopyStructure = async (val, direct) => {
  const datas = await http.post(`${URL + copy_structure}`, val);
  if (direct) {
    return datas.data;
  }
  return datas.data.data;
};

export const apiListDivision = async (val) => {
  const datas = await http.post(`${URL + list_division}`, val);
  return datas.data.data;
};

export const apiAddEmployee = async (val) => {
  const datas = await http.post(`${URL + add_employee}`, val);
  return datas.data;
};

export const apiEditEmployee = async (val) => {
  const datas = await http.post(`${URL + edit_employee}`, val);
  return datas.data;
};
export const apiOrganizationNoLimit = async (val) => {
  const datas = await http.post(`${URL + list_structure_noLimit}`, val);

  return datas.data.data;
};
